import { useRef, useState, useEffect, CSSProperties, ChangeEvent } from 'react'
import cx from 'classnames'
import FormLabel from './FormLabel'
import FormError from './FormError'
import s from './style.module.scss'
import { matValidatorFn } from '@/helpers/matValidatorFn'

interface IInputProps {
  name: string
  id?: string
  className?: string
  classNameInputWrapper?: string
  style?: CSSProperties
  onChange?: (event: ChangeEvent<HTMLInputElement>) => void
  defaultValue?: string | boolean | Record<string, any>
  value?: any
  label?: string
  placeholder?: string
  disabled?: boolean
  required?: boolean
  register?: any
  rules?: any
  errors?: any
  fluid?: boolean
  textCenter?: boolean
  showLabelRequired?: boolean
  rows?: number
  view?: 'primary' | string
  autoHeight?: boolean
  isResetHeight?: boolean
  scores?: number
  validateMat?: boolean
}

const Textarea = ({
  id,
  name,
  className,
  classNameInputWrapper,
  style,
  onChange,
  defaultValue,
  value,
  label,
  placeholder,
  disabled,
  required,
  register,
  rules,
  errors,
  fluid,
  textCenter,
  showLabelRequired,
  rows,
  view = 'auth',
  autoHeight,
  isResetHeight,
  scores,
  validateMat,
  ...rest
}: IInputProps) => {
  const inputRef = useRef<HTMLDivElement | null>(null)
  const [validation, setValidation] = useState<any>(null)
  const [isRequired, setIsRequired] = useState<boolean>(false)

  const formInputWrapperClassList = cx(
    s['form-input-wrapper'],
    {
      [s.error]: errors?.[name] || errors?.ref?.name === name,
      [s.fluid]: fluid,
      [s[`view-${view}`]]: view
    },
    classNameInputWrapper
  )

  const inputClassList = cx(
    s.input,
    s.textarea,
    {
      // [s.error]: errors?.[name] || errors?.ref?.name === name,
      [s['text-center']]: textCenter,
      [s['auto-height']]: autoHeight
    },
    className
  )

  useEffect(() => {
    setValidation(
      register
        ? {
            ...register(name, {
              ...rules,
              validate: validateMat ? matValidatorFn : undefined,
              onChange: (e: any) => (onChange ? onChange(e) : null)
            })
          }
        : null
    )
    setIsRequired(required || rules?.required?.value)
    // TODO: Проверить зависимости и включить правило
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    if (autoHeight && value && inputRef?.current?.lastElementChild) {
      inputRef.current.lastElementChild.style.height = 'auto'
      inputRef.current.lastElementChild.style.height = `${Math.max(
        inputRef.current.lastElementChild.scrollHeight,
        50
      )}px`
    }
    // TODO: Проверить зависимости и включить правило
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value, autoHeight])

  useEffect(() => {
    if (isResetHeight && inputRef?.current?.lastElementChild) {
      inputRef.current.lastElementChild.style.height = 'auto'
    }
    // TODO: Проверить зависимости и включить правило
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isResetHeight])

  return (
    <label className={formInputWrapperClassList}>
      <FormLabel label={label} required={isRequired && showLabelRequired} />
      <div className={s['input-container']} ref={inputRef}>
        <textarea
          id={id}
          name={name}
          className={inputClassList}
          style={style}
          onChange={onChange}
          defaultValue={defaultValue}
          value={value}
          placeholder={placeholder}
          disabled={disabled}
          rows={!rows && autoHeight ? 1 : rows}
          {...validation}
          {...rest}
        />
        {Boolean(scores) && (
          <div className={s.scores}>
            <div className={s['star-icon']} /> +{scores}
          </div>
        )}
      </div>
      <FormError message={errors?.[name]?.message || (errors?.ref?.name === name && errors?.message)} />
    </label>
  )
}

export default Textarea
